import styled from 'styled-components';
import { getBaseTheme } from '@Themes';

const { texts, spaces, colors } = getBaseTheme();

const Div = styled.div`
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Header = styled(Div)`
    padding: ${spaces.default.xs};

    > h4 {
        color: #75757a;
    }
`;

export const LinkWrapper = styled(Div)`
    padding: ${spaces.default.xs};
    font-size: 1.25rem;

    > a {
        text-decoration: none;
        color: ${colors.control.default.foregroundColor};

        :focus {
            outline: none;
        }
        :hover {
            color: #0168fe;
            text-decoration: underline;
        }
    }
`;

export const InnerFrameWrapper = styled.div`
    min-height: 200px;
    max-height: 550px;
    overflow-y: scroll;
    word-wrap: break-word;
    padding: ${spaces.default.xs};

    > ul {
        margin: 0;
        padding: 0 ${spaces.default.m};
        ${texts.sizes.s};

        > li {
            padding-bottom: ${spaces.default.s};
        }
    }
`;

export const Footer = styled(Div)`
    padding: ${spaces.default.xs} ${spaces.default.xs} 0;
    > input {
        :focus {
            outline: none;
        }
    }
`;

export const ReleaseNotesDialogWrapper = styled.div`
    background-color: #fff;
`;
